const config = {
  SAMS_ENDPOINT: 'https://sams2.usps.gov/sams-intl-ws/assignment/fetchbyupu/MIA/',
    ENDPOINT: '/dangerous-ws',
    BASE_URL: '/dangerous-goods-web',
    CLIENT_ID: '0oahrwdoguyDrt9i44h7',
    OKTA_URL: 'https://login.usps.gov/oauth2/aus59ik9q9ijg0XY94h7/v1/authorize',
    CLIENT_SECRET: 'OtS9fYlgBSiXkNQhj9vfGYOhTFwWDMbD_fdVbUTjHQECuhoIwO2Ys8oWSOp2XZW9',
    ISSUER: 'https://login.usps.gov/oauth2/aus59ik9q9ijg0XY94h7',
    // LOGIN: 'external' // For SIT-External, PROD-External
    LOGIN: 'internal'  // For DEV, CAT, PROD-Internal  
  }
  
  export default config
  